export var WaMgmtPageState;
(function (WaMgmtPageState) {
    WaMgmtPageState["INIT"] = "INIT";
    WaMgmtPageState["QRCODE"] = "QRCODE";
    WaMgmtPageState["AUTH"] = "AUTH";
    WaMgmtPageState["LOGIN"] = "LOGIN";
    WaMgmtPageState["READY"] = "READY";
    WaMgmtPageState["BIND_ERROR"] = "BIND_ERROR";
})(WaMgmtPageState || (WaMgmtPageState = {}));
export var WaCrmLabelType;
(function (WaCrmLabelType) {
    WaCrmLabelType[WaCrmLabelType["myCustomer"] = 4] = "myCustomer";
    WaCrmLabelType[WaCrmLabelType["openSeaCustomer"] = 7] = "openSeaCustomer";
    WaCrmLabelType[WaCrmLabelType["colleagueCustomer"] = 8] = "colleagueCustomer";
    WaCrmLabelType[WaCrmLabelType["colleagueCustomerNoAuth"] = 9] = "colleagueCustomerNoAuth";
    WaCrmLabelType[WaCrmLabelType["myClue"] = 1] = "myClue";
    WaCrmLabelType[WaCrmLabelType["openSeaClue"] = 3] = "openSeaClue";
    WaCrmLabelType[WaCrmLabelType["colleagueClue"] = 10] = "colleagueClue";
    WaCrmLabelType[WaCrmLabelType["colleagueClueNoAuth"] = 11] = "colleagueClueNoAuth";
})(WaCrmLabelType || (WaCrmLabelType = {}));
export const WaCrmLabelTypeName = {
    [WaCrmLabelType.myCustomer]: '我的客户',
    [WaCrmLabelType.openSeaCustomer]: '公海客户',
    [WaCrmLabelType.colleagueCustomer]: '同事客户',
    [WaCrmLabelType.colleagueCustomerNoAuth]: '同事客户',
    [WaCrmLabelType.myClue]: '我的线索',
    [WaCrmLabelType.openSeaClue]: '公海线索',
    [WaCrmLabelType.colleagueClue]: '同事线索',
    [WaCrmLabelType.colleagueClueNoAuth]: '同事线索',
};
export const WaCrmLabelTypeMap = {
    [WaCrmLabelType.myCustomer]: 'myCustomer',
    [WaCrmLabelType.openSeaCustomer]: 'openSeaCustomer',
    [WaCrmLabelType.colleagueCustomer]: 'colleagueCustomer',
    [WaCrmLabelType.colleagueCustomerNoAuth]: 'colleagueCustomerNoAuth',
    [WaCrmLabelType.myClue]: 'myClue',
    [WaCrmLabelType.openSeaClue]: 'openSeaClue',
    [WaCrmLabelType.colleagueClue]: 'colleagueClue',
    [WaCrmLabelType.colleagueClueNoAuth]: 'colleagueClueNoAuth',
};
export var WaMessageType;
(function (WaMessageType) {
    WaMessageType["CHAT_MESSAGE_REVOKE_EVERYONE"] = "CHAT_MESSAGE_REVOKE_EVERYONE";
    WaMessageType["CHAT_MESSAGE_REVOKE_ME"] = "CHAT_MESSAGE_REVOKE_ME";
    WaMessageType["CHAT_REMOVED"] = "CHAT_REMOVED";
    WaMessageType["CHAT_TRANSFER"] = "CHAT_TRANSFER";
    WaMessageType["SEND_KEYWORD"] = "SEND_KEYWORD";
})(WaMessageType || (WaMessageType = {}));
export var ModeType;
(function (ModeType) {
    ModeType["free"] = "free";
    ModeType["limit"] = "limit";
    ModeType["allocation"] = "allocation";
})(ModeType || (ModeType = {}));
export var WaFrameworkVersion;
(function (WaFrameworkVersion) {
    WaFrameworkVersion["baileys"] = "BAILEYS";
    WaFrameworkVersion["waWebJs"] = "WHATSAPP_WEB_JS";
})(WaFrameworkVersion || (WaFrameworkVersion = {}));
